/* Malicious Threads · Log Hunt. The puzzle is generated and judged on the server; the answer arrives only when you're done. */
(function () {
  'use strict';
  var root = document.getElementById('mt-lh'); if (!root || !window.MTG) return;
  var G = window.MTG, el = G.el, $ = function (id) { return document.getElementById(id); };
  var API = root.getAttribute('data-api') || '/apps/ctf/loghunt', SIGNED_IN = root.getAttribute('data-signed-in') === '1';
  var LOGIN = root.getAttribute('data-login'), SHARE_URL = root.getAttribute('data-share'), NEXT = root.getAttribute('data-next'), HUB = root.getAttribute('data-hub');
  var KEY = 'mt-lh-v1', say = G.sayer($('lh-msg')), md = G.modals(root);
  var S = null, sel = -1, busy = false, stopCd = null, hintsOpen = false;
  var log = $('lh-log'), go = $('lh-go'), end = $('lh-end'), bar = $('lh-bar');
  function saveGuest(st) {
    if (SIGNED_IN) return;
    var o = G.load(KEY); if (o.epoch !== st.epoch) o = { epoch: st.epoch, h: '' };
    o.game = { day: st.day, st: st };
    if (st.status !== 'playing') { var k = st.clicks.map(function (c) { return c.i; }).indexOf(st.answer); o.h = G.mark(o.h, st.day, k >= 0 ? String(k + 1) : 'x'); }
    G.save(KEY, o);
  }
  function render() {
    root.classList.toggle('is-playing', S.status === 'playing');
    $('lh-sub').textContent = '#' + S.number + ' · ' + S.difficulty + ' · 25 lines · 4 tries';
    $('lh-prompt').textContent = '🔍 ' + S.prompt;
    $('lh-src').textContent = S.sourceLabel;
    var left = $('lh-left'); left.innerHTML = '';
    for (var k = 0; k < S.maxClicks; k++) { var d = el('i'); if (k < S.clicks.length) d.className = 'used'; left.appendChild(d); }
    left.appendChild(document.createTextNode(' ' + (S.maxClicks - S.clicks.length) + ' left'));
    var hints = $('lh-hints'); hints.innerHTML = '';
    S.hints.forEach(function (h, i) { hints.appendChild(el('div', 'lh-hint', 'Hint ' + (i + 1) + ': ' + h)); });
    if (S.hints.length > 1) {   // full screen on a phone shows only the newest hint; earlier ones are a tap away
      var more = el('button', 'lh-more'); more.type = 'button';
      more.addEventListener('click', function () { hintsOpen = !hintsOpen; paintHints(); });
      hints.appendChild(more);
    }
    paintHints();
    var wrong = {}, ok = -1; S.clicks.forEach(function (c) { if (c.ok) ok = c.i; else wrong[c.i] = 1; });
    var decoys = {}; (S.decoys || []).forEach(function (d) { decoys[d.i] = d.note; });
    log.innerHTML = '';
    S.lines.forEach(function (line, i) {
      var b = el('button', 'lh-line'); b.type = 'button'; b.setAttribute('role', 'listitem'); b.setAttribute('data-i', i);
      b.appendChild(el('span', 'n', String(i + 1))); b.appendChild(el('span', null, line));
      if (wrong[i]) { b.className += ' is-no'; b.disabled = true; b.setAttribute('aria-label', 'Line ' + (i + 1) + ', wrong guess'); }
      if (S.status !== 'playing') { b.disabled = true; if (i === S.answer) b.className = 'lh-line is-ok'; else if (decoys[i] != null) b.className += ' is-decoy'; }
      if (i === sel && S.status === 'playing') b.className += ' is-sel';
      log.appendChild(b);
    });
    if (S.status === 'playing') { bar.hidden = false; go.disabled = sel < 0; $('lh-pick').textContent = sel < 0 ? 'Tap the line you think is the attack.' : 'Line ' + (sel + 1) + ' selected.'; end.hidden = true; }
    else { bar.hidden = true; finish(); }
  }
  function paintHints() {
    var hints = $('lh-hints'), more = hints.querySelector('.lh-more'), n = S.hints.length - 1;
    hints.classList.toggle('is-open', hintsOpen);
    if (more) { more.textContent = hintsOpen ? '[ hide ]' : '[ +' + n + ' earlier ]'; more.setAttribute('aria-label', hintsOpen ? 'Hide earlier hints' : 'Show ' + n + ' earlier hint' + (n > 1 ? 's' : '')); more.setAttribute('aria-expanded', hintsOpen ? 'true' : 'false'); }
  }
  function shareText() {
    var marks = S.clicks.map(function (c) { return c.ok ? '✅' : '❌'; }).join('');
    return '🔍 Log Hunt #' + S.number + ' (' + S.difficulty + ')\n' + marks + (S.status === 'found' ? ' found in ' + S.clicks.length : ' not found') + '\n' + SHARE_URL;
  }
  function finish() {
    end.hidden = false; end.innerHTML = '';
    if (S.awarded && S.awarded.length) say('Streak reward: +' + S.awarded.map(function (a) { return a.points; }).join(' +') + ' CTF points!', 'is-ok', 6000);
    var found = S.status === 'found';
    end.appendChild(el('h2', null, found ? (S.clicks.length === 1 ? 'First try. You\'d make a good SOC lead.' : 'Found it in ' + S.clicks.length + '.') : 'It got past you.'));
    end.appendChild(el('div', null, 'Line ' + (S.answer + 1) + ' was the attack: ' + S.name + '.'));
    var at = el('div'); at.appendChild(document.createTextNode('MITRE ATT&CK ')); var a = el('a', null, S.attack.id + ' ' + S.attack.name); a.href = 'https://attack.mitre.org/techniques/' + S.attack.id.replace('.', '/') + '/'; a.target = '_blank'; a.rel = 'noopener'; at.appendChild(a); at.appendChild(document.createTextNode(' · ' + S.tactic)); end.appendChild(at);
    end.appendChild(el('div', null, S.explain));
    if (S.decoys && S.decoys.length) {
      end.appendChild(el('div', 'gm-h3', 'Red herrings'));
      var dl = el('div', 'lh-decoys'); S.decoys.forEach(function (d) { dl.appendChild(el('div', null, 'Line ' + (d.i + 1) + ': ' + d.note)); }); end.appendChild(dl);
    }
    var btns = el('div', 'gm-btns');
    var sh = el('button', 'gm-btn', '[ SHARE ]'); sh.type = 'button'; sh.addEventListener('click', function () { G.share(sh, shareText(), end, say); }); btns.appendChild(sh);
    var stb = el('button', 'gm-btn gm-btn--ghost', '[ STATS ]'); stb.type = 'button'; stb.addEventListener('click', openStats); btns.appendChild(stb);
    end.appendChild(btns);
    var nx = el('div', 'gm-next'); nx.appendChild(document.createTextNode('Daily pack: ')); var n1 = el('a', null, 'Passwordle'); n1.href = NEXT; nx.appendChild(n1); nx.appendChild(document.createTextNode(' · ')); var n2 = el('a', null, 'your streak →'); n2.href = HUB; nx.appendChild(n2); end.appendChild(nx);
    var cd = el('div', 'gm-next'); cd.appendChild(document.createTextNode('Next log in ')); var b = el('b', 'mt-g'); cd.appendChild(b); end.appendChild(cd);
    if (stopCd) stopCd(); stopCd = G.countdown(b, S.resetsAt, boot);
  }
  function openStats() {
    if (!S) return;
    var st = SIGNED_IN && S.stats ? S.stats : G.guestStats((function () { var o = G.load(KEY); return o.epoch === S.epoch ? o.h || '' : ''; })(), 'lh');
    var ch = st.history && st.history[S.day];
    G.statsBody($('lh-stats-body'), st, S.day, 'lh', SIGNED_IN, LOGIN, ch && ch !== '.' ? ch : null);
    md.open('lh-stats');
  }
  function accuse() {
    if (busy || !S || S.status !== 'playing' || sel < 0) return;
    busy = true; go.disabled = true;
    G.api(API, 'POST', { day: S.day, line: sel, clicks: S.clicks.map(function (c) { return c.i; }) }).then(function (j) {
      busy = false;
      if (!j.ok) {
        if (j.error === 'new_day') { say(j.message, '', 3000); return boot(); }
        if (j.error === 'game_over' && j.state) { S = j.state; return render(); }
        if (j.error === 'bad_prev') { var o = G.load(KEY); delete o.game; G.save(KEY, o); return boot(); }
        say(j.message || 'Something went wrong. Try again.', 'is-bad', 3000); go.disabled = false; return;
      }
      var wasRight = j.clicks[j.clicks.length - 1].ok;
      S = j; sel = -1; saveGuest(S);
      if (S.status === 'playing') say(wasRight ? '' : 'Not that one. ' + (S.maxClicks - S.clicks.length) + ' left. New hint: ' + S.hints[S.hints.length - 1], 'is-bad', 5000);
      else say(S.status === 'found' ? 'Got it.' : 'Out of tries.', S.status === 'found' ? 'is-ok' : 'is-bad', 3000);
      render();
      if (S.status !== 'playing') end.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  function boot() {
    sel = -1;
    G.api(API).then(function (j) {
      if (!j.ok) { say(j.error === 'offline' || j.error === 'network' ? 'The game server is offline right now. Try again shortly.' : (j.message || 'Could not load the game.'), 'is-bad'); return; }
      if (!SIGNED_IN) {
        var o = G.load(KEY);
        if (o.epoch === j.epoch && o.game && o.game.day === j.day && o.game.st && o.game.st.lines && o.game.st.lines.join('\n') === j.lines.join('\n')) j = o.game.st;
      }
      S = j; render();
      try { if (!localStorage.getItem('mt-lh-seen')) { localStorage.setItem('mt-lh-seen', '1'); md.open('lh-help'); } } catch (_) { /* ignore */ }
    });
  }
  log.addEventListener('click', function (e) {
    var b = e.target.closest('.lh-line'); if (!b || b.disabled || !S || S.status !== 'playing') return;
    select(Number(b.getAttribute('data-i')));
  });
  function select(i) {
    sel = i;
    log.querySelectorAll('.lh-line').forEach(function (x) { x.classList.toggle('is-sel', Number(x.getAttribute('data-i')) === sel); });
    go.disabled = sel < 0; $('lh-pick').textContent = sel < 0 ? 'Tap the line you think is the attack.' : 'Line ' + (sel + 1) + ' selected.';
  }
  log.addEventListener('dblclick', function (e) { var b = e.target.closest('.lh-line'); if (b && !b.disabled && S && S.status === 'playing') { select(Number(b.getAttribute('data-i'))); accuse(); } });
  go.addEventListener('click', accuse);
  $('lh-help-btn').addEventListener('click', function () { md.open('lh-help'); });
  $('lh-stats-btn').addEventListener('click', openStats);
  boot();
})();
